// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220335/js/" + chunkId + "." + {"44":"b5224ab8","225":"43a6b65a","481":"8b7e4421","486":"da7f8149","770":"8e528ad3"}[chunkId] + ".0.5795915536181997.chunk.js";
};